<nav class="menu">
    <div>
        <ul class="list">
            <a *ngFor="let item of menuItems; let i = index" (click)="selectItem(i)" class="link"
                [class.active]="selectedIndex === i">
                <li class="item">
                    <div>
                        <ng-container [ngSwitch]="item.icon">
                            <app-windows *ngSwitchCase="'windows'"></app-windows>
                            <app-happy-mac *ngSwitchCase="'macos'"></app-happy-mac>
                            <app-android *ngSwitchCase="'android'"></app-android>
                            <app-list *ngSwitchCase="'ios'"></app-list>
                            <app-chrome *ngSwitchCase="'chrome'"></app-chrome>
                            <app-chrome *ngSwitchCase="'edge'"></app-chrome>
                        </ng-container>
                    </div>
                    <span class="text">{{ item.label }}</span>
                </li>
            </a>
        </ul>
    </div>
</nav>